<template>
  <transition name="fade">
    <div class="popup" id="popup_upload_photo" @click="$store.commit('uploadPhoto', false)">
      <div class="popup_block" @click.stop>
        <div class="close" @click="$store.commit('uploadPhoto', false)"></div>
        <div class="pos_relative">
          <div class="img_load">
            <vue-avatar
              :width="270"
              :height="270"
              :rotation="rotation"
              :scale="scale"
              id="avatarEditor"
              :borderRadius="borderRadius"
              ref="vueavatar"
              @vue-avatar-editor:image-ready="onImageReady"
              :image="image"
            ></vue-avatar>
          </div>
          <div class="select-image">
            <button @click="inputTrigerrClick()">{{ $store.getters.t('select') }}</button>
          </div>
          <div class="block_roller">
            <div class="div_relative">
              <div class="roller">
                <div class="name_number">
                  <div class="name_roller">
                    <p>{{$store.getters.t('Zoom')}}</p>
                  </div>
                  <div class="number_roller">{{ scale.toFixed(1) + 'x'}}</div>
                </div>
                <vue-slider v-model="scale" :min="1" :max="3" :interval="0.2"/>
              </div>
            </div>
            <div class="div_relative">
              <div class="roller">
                <div class="name_number">
                  <div class="name_roller">
                    <p>{{$store.getters.t('Rotation')}}</p>
                  </div>
                  <div class="number_roller">{{ rotation.toFixed(1) + '°'}}</div>
                </div>
                <vue-slider v-model="rotation" :min="0" :max="360"/>
              </div>
            </div>
            <!--<div class="div_relative">-->
              <!--<div class="roller">-->
                <!--<div class="name_number">-->
                  <!--<div class="name_roller">-->
                    <!--<p>{{$store.getters.t('Illustrator')}}</p>-->
                  <!--</div>-->
                  <!--<div class="number_roller">{{ borderRadius.toFixed(1) + '%'}}</div>-->
                <!--</div>-->
                <!--<vue-slider v-model="borderRadius" :min="0" :max="100"/>-->
              <!--</div>-->
            <!--</div>-->
          </div>
          <form @submit.prevent>
            <input
              class="submit_button"
              type="submit"
              :value="$store.getters.t('save')"
              v-on:click="saveClicked"
            >
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { VueAvatar } from "vue-avatar-editor-improved";
import VueSlider from "vue-slider-component";

export default {
  props: ["image", "dataUrl"],
  components: {
    VueAvatar,
    VueSlider
  },
  data() {
    return {
      rotation: this.$store.getters.user.avatar
        ? this.$store.getters.user.avatar.rotation
        : 0,
      scale: this.$store.getters.user.avatar
        ? this.$store.getters.user.avatar.scale
        : 1,
      borderRadius: this.$store.getters.user.avatar
        ? this.$store.getters.user.avatar.borderRadius
        : 0,
      img: false,
      reset: this.$store.getters.user.avatar
        ? { scale: true, rotation: true, borderRadius: true }
        : false
    };
  },
  watch: {
    scale(to, from) {
      if (this.reset && this.reset.scale) {
        this.reset.scale = false;
        this.scale = from;
      }
    },
    rotation(to, from) {
      if (this.reset && this.reset.rotation) {
        this.reset.rotation = false;
        this.rotation = from;
      }
    },
    borderRadius(to, from) {
      if (this.reset && this.reset.borderRadius) {
        this.reset.borderRadius = false;
        this.borderRadius = from;
      }
    }
  },
  methods: {
    inputTrigerrClick() {
      document
        .getElementById("avatarEditor")
        .getElementsByTagName("input")[0]
        .click();
    },
    saveClicked() {
      if (this.img) {
        let img = this.$refs.vueavatar.getImageScaled();
        let formData = new FormData();
        let file = document
          .getElementById("avatarEditor")
          .getElementsByTagName("input")[0].files[0];
        if (file !== undefined) {
          formData.append("photo", file);
        }
        formData.append(
          "avatar",
          JSON.stringify({
            scale: this.scale,
            borderRadius: this.borderRadius,
            rotation: this.rotation,
            image: img.toDataURL()
          })
        );
        NProgress.start();
        this.$http({
          method: "post",
          url: this.dataUrl,
          data: formData
        }).then(res => {
          if (res) {
            if (res.data.success) {
              this.$store.commit("uploadPhoto", false);
              this.$store.commit("newMessage", {
                show: true,
               type: "success",
                messageTitle: this.$store.getters.t("success"),
                message: this.$store.getters.t("image_change")
              });
              if (res.data.user) {
                this.$store.commit("user", res.data.user);
              }
            }
          }
          NProgress.done();
        }).catch(error => {
          this.$store.commit("newMessage", {
            show: true,
            type: "error",
            messageTitle: this.$store.getters.t("error"),
            message: this.$store.getters.t(error.response.data.photo[0])
          });
        });
      } else {
      
      }
    },
    onImageReady() {
      this.img = true;
      this.scale = 1;
      this.rotation = 0;
      this.borderRadius = 0;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/modals/avatar-editor.vue